import React, { useEffect, useState } from "react";
import { GetAllNotifications, MarkNotificationAsRead } from "../../Services/NotificationService";
import {NotificationConnection,startNotificationConnection} from "../../signalr/NotificationConnection";
import { useNavigate } from "react-router-dom";

export default function Notifications() {
  const [list, setList] = useState([]);
  const [type, setType] = useState("all"); 
  const navigate = useNavigate();

  const CURRENT_USER_ID = Number(localStorage.getItem("userId") || 1);

  // counts se UI par dikhayenge
  const [counts, setCounts] = useState({
    totalUnread: 0,
    orderCreatedUnread: 0,
    orderCompletedUnread: 0,
    newUserUnread: 0
  });

  const loadData = async () => {
    const params = {
      adminId: CURRENT_USER_ID,
      role: "Admin",
      type
    };

    const res = await GetAllNotifications(params);

    setList(res.data.notificationList || []);

    setCounts({
      totalUnread: res.data.totalUnread,
      orderCreatedUnread: res.data.orderCreatedUnread,
      orderCompletedUnread: res.data.orderCompletedUnread,
      newUserUnread: res.data.newUserUnread
    });
  };

  useEffect(() => {
    const init = async () => {
      await startNotificationConnection(); // IMPORTANT: wait

      loadData(); // first load

      NotificationConnection.on("ReceiveNotification", () => {
        loadData();  // realtime refresh
      });

      // 🔹 Read/updated notifications
      NotificationConnection.on("NotificationUpdated", () => {
        loadData(); // refresh counts + list
      });
    };

    init();

    return () => {
      NotificationConnection.off("ReceiveNotification");
      NotificationConnection.off("NotificationUpdated");
    };
}, []);


// 🔵 This useEffect is OK → type change par refresh chahiye
useEffect(() => {
  loadData();
}, [type]);

  const handleRead = async (id) => {
    var res = await MarkNotificationAsRead(id, CURRENT_USER_ID);
    if (!res.status) {
      alert(res.message);
    }
  };

  return (
    <div className="container mt-4">
      <h3>Notifications</h3>

      {/* 🔵 TABS  */}
      <div className="mt-3 d-flex gap-2">

        <button
          className={`btn btn-sm ${type === "all" ? "btn-primary" : "btn-outline-primary"}`}
          onClick={() => {
            setType("all");
          }}
        >
          All ({counts.totalUnread})
        </button>

        <button
          className={`btn btn-sm ${type === "OrderCreated" ? "btn-primary" : "btn-outline-primary"}`}
          onClick={() => setType("OrderCreated")}
        >
          Order Created ({counts.orderCreatedUnread})
        </button>

        <button
          className={`btn btn-sm ${type === "OrderCompleted" ? "btn-primary" : "btn-outline-primary"}`}
          onClick={() => setType("OrderCompleted")}
        >
          Order Completed ({counts.orderCompletedUnread})
        </button>

        <button
          className={`btn btn-sm ${type === "NewUser" ? "btn-primary" : "btn-outline-primary"}`}
          onClick={() => setType("NewUser")}
        >
          New User ({counts.newUserUnread})
        </button>

      </div>

      {/* 🔵 NOTIFICATION LIST */}
      <div className="mt-3">
        {list.length === 0 && <p>No notifications found.</p>}

        {list.map((n) => (
          <div
            key={n.notificationId}
            className="p-3 mb-2 rounded"
            style={{ background: n.isRead ? "#f1f1f1" : "#e6f7ff" }}
          >
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <strong>{n.title}</strong>
                <div>{n.message}</div>
                <small className="text-muted">
                  {new Date(n.createdAt).toLocaleString()}
                </small>
              </div>

              {n.orderId !== null && (
                <button
                  className="btn btn-sm btn-primary"
                  onClick={() => navigate('/orders', { state: { orderId: n.orderId } })}
                >
                  View Details
                </button>
              )}

              {!n.isRead && (
                <button
                  className="btn btn-sm btn-primary"
                  onClick={() => handleRead(n.notificationId)}
                >
                  Mark as read
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}